export default "__VITE_ASSET__DN_$nxR6__"